// @flow
import {LINGUA_TITLE_KEY_BOTTOM_CAROUSEL} from '../DestinationCarousel/constants';

const RESULT_LISTING_COUNT_LIMIT = 50;
export const getTitleKeyByCount = (resultListingCount: number) =>
    resultListingCount > RESULT_LISTING_COUNT_LIMIT
        ? LINGUA_TITLE_KEY_BOTTOM_CAROUSEL.carousel_title_large_result
        : LINGUA_TITLE_KEY_BOTTOM_CAROUSEL.carousel_title_small_result;
